/** @format */

import {DailySeries, IsoDate} from '../types';

export const sumSeries = (series: DailySeries): number =>
  Object.values(series).reduce((acc, value) => acc + value, 0);

export const sumSeriesToDate = (series: DailySeries, today: IsoDate): number =>
  Object.keys(series).reduce((acc, key) => (key <= today ? acc + series[key] : acc), 0);
